import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { config } from '@/config';

export function LoginPage() {
  const { login, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const [loginClicked, setLoginClicked] = useState(false);

  // After MSAL processes the auth code, redirect to the original page or /home
  if (isAuthenticated) {
    const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/home';
    return <Navigate to={from} replace />;
  }

  if (isLoading || loginClicked) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-surface-50 dark:bg-mica-bg">
        <div className="text-center">
          <div className="spinner mb-3" />
          <p className="text-sm text-surface-500">Signing in...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-surface-50 dark:bg-mica-bg">
      <div className="card p-8 w-full max-w-sm text-center animate-fade-in">
        {/* Brand */}
        <div className="flex justify-center mb-5">
          <div className="w-14 h-14 rounded-fluent-lg bg-brand-500 flex items-center justify-center shadow-glow-brand">
            <span className="text-white text-2xl font-bold">W</span>
          </div>
        </div>
        <h1 className="text-lg font-semibold text-surface-900 dark:text-surface-100 mb-0.5">
          {config.appName}
        </h1>
        <p className="text-sm text-surface-500 mb-8">Cloud Platform Portal</p>

        <button
          onClick={() => {
            setLoginClicked(true);
            login();
          }}
          className="btn-primary w-full"
        >
          Sign in with Microsoft
        </button>

        <p className="text-xs text-surface-400 mt-6">Use your organizational account to sign in.</p>
      </div>
    </div>
  );
}
